export default __webpack_public_path__ + "static/what's-app-message-69fd8a73a2c8be9d783988c51aa54aa1.svg";